export default "__VITE_ASSET__CF4_AtYx__"